var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgS3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 51,
    viewBox: "0 0 51 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M51 25.5C51 39.5831 39.5831 51 25.5 51C11.4183 51 0 39.5831 0 25.5C0 11.4183 11.4183 0 25.5 0C39.5831 0 51 11.4183 51 25.5Z",
    fill: "#FFCC4D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2897 28.3337C18.2457 28.3337 19.8314 26.1137 19.8314 23.3753C19.8314 20.6369 18.2457 18.417 16.2897 18.417C14.3337 18.417 12.748 20.6369 12.748 23.3753C12.748 26.1137 14.3337 28.3337 16.2897 28.3337Z",
    fill: "#664500"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7057 28.3337C36.6617 28.3337 38.2474 26.1137 38.2474 23.3753C38.2474 20.6369 36.6617 18.417 34.7057 18.417C32.7497 18.417 31.1641 20.6369 31.1641 23.3753C31.1641 26.1137 32.7497 28.3337 34.7057 28.3337Z",
    fill: "#664500"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.416 36.8333H15.5827C14.8007 36.8333 14.166 36.2001 14.166 35.4167C14.166 34.6332 14.8007 34 15.5827 34H35.416C36.1994 34 36.8327 34.6332 36.8327 35.4167C36.8327 36.2001 36.1994 36.8333 35.416 36.8333Z",
    fill: "#664500"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgS3);
export default __webpack_public_path__ + "static/media/s3.bb151fcf71a5eddd68ed43118fa014ad.svg";
export { ForwardRef as ReactComponent };